module.exports = __webpack_public_path__ + "static/media/cervixcancer.3ab0aeca.svg";